import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {environment} from 'src/environments/environment';
import { UtilService } from './util';
import { Zpr } from '../interface/zpr';
import { PoTableColumn } from '@po-ui/ng-components';
import { BaseSX5 } from '../interface/base';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  url = `${environment.urlApiProtheus}/wsrbase`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
    ) {
  }

  getZPR(CZPRGRUPO: string, CZPRCHAVE: string, showMensagemRetorno: boolean = true): Observable<Zpr> {
    const httpOptions = this.utilService.filtrosHttpOptions({},showMensagemRetorno);
    return this.httpClient.get<Zpr>(`${this.url}/zpr/${CZPRGRUPO}/${CZPRCHAVE}`,httpOptions);
  }

  getValidaCGC(cgc: string){
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get(`${this.url}/cgc/${cgc}`,httpOptions);
  }

  getDadosCNPJ(cgc: string):Observable<any> {
    return this.httpClient.jsonp(`https://www.receitaws.com.br/v1/cnpj/${cgc}`,"callback");
  }

  public readonly colunasListaSX5: Array<PoTableColumn> = [
    {property: 'CX5CHAVE' , label: 'Chave'},
    {property: 'CX5DESCRI', label: 'Descrição'},

  ];

  getFieldFormaterSX5(value: BaseSX5): string {
    return `${value.CX5CHAVE} - ${value.CX5DESCRI}`;
  }

}
